// @flow

import React from 'react';
import { ReactComponent as AddIcon } from '../../../assets/icons/svg/add.svg';
import { ReactComponent as ArrowRightIcon } from '../../../assets/icons/svg/arrow-right.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/svg/calendar.svg';
import { ReactComponent as CarouselArrowIcon } from '../../../assets/icons/svg/carousel-arrow.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/svg/close.svg';
import { ReactComponent as CloseSquareIcon } from '../../../assets/icons/svg/close-square.svg';
import { ReactComponent as EditIcon } from '../../../assets/icons/svg/edit.svg';
import { ReactComponent as EyeStrikedIcon } from '../../../assets/icons/svg/eye-striked.svg';
import { ReactComponent as EyeIcon } from '../../../assets/icons/svg/eye.svg';
import { ReactComponent as FemaleIcon } from '../../../assets/icons/svg/female.svg';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/svg/icon_arrow_down.svg';
import { ReactComponent as ArrowUpIcon } from '../../../assets/icons/svg/icon_arrow_up.svg';
import { ReactComponent as MaleIcon } from '../../../assets/icons/svg/male.svg';
import { ReactComponent as PlayIcon } from '../../../assets/icons/svg/play.svg';
import { ReactComponent as ScanIcon } from '../../../assets/icons/svg/scan.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/svg/upload.svg';
import { ReactComponent as ValidateIcon } from '../../../assets/icons/svg/validate.svg';
import { ReactComponent as LockIcon } from '../../../assets/icons/svg/lock.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/svg/info.svg';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/svg/exclamation.svg';

import { ReactComponent as PaypalIcon } from '../../../assets/icons/svg/paypal.svg';

type IconProps = {|
  size?: number,
  name: string,
|};

const getResource = (name) => {
  switch (name) {
    case 'add':
      return AddIcon;
    case 'arrow-right':
      return ArrowRightIcon;
    case 'calendar':
      return CalendarIcon;
    case 'carousel-arrow':
      return CarouselArrowIcon;
    case 'close':
      return CloseIcon;
    case 'close-square':
      return CloseSquareIcon;
    case 'edit':
      return EditIcon;
    case 'eye-striked':
      return EyeStrikedIcon;
    case 'eye':
      return EyeIcon;
    case 'female':
      return FemaleIcon;
    case 'icon_arrow_down':
      return ArrowDownIcon;
    case 'icon_arrow_up':
      return ArrowUpIcon;
    case 'male':
      return MaleIcon;
    case 'play':
      return PlayIcon;
    case 'scan':
      return ScanIcon;
    case 'upload':
      return UploadIcon;
    case 'validate':
      return ValidateIcon;
    case 'paypal':
      return PaypalIcon;
    case 'lock':
      return LockIcon;
    case 'info':
      return InfoIcon;
    case 'exclamation':
      return ExclamationIcon;
    default:
      return null;
  }
};

export const Icon = ({ name, size = 22 }: IconProps) => {
  const Resource = getResource(name);
  return Resource && <Resource size={size} />;
};
